
import { reactive } from 'vue'

export const headerState = reactive({
    title: '',
    subtitle: '',
    routerKey: 0,
    clear() {
        this.title = ''
        this.subtitle = ''
    },
    clearSubtitle() {
        this.subtitle = ''
    },
    refreshView() {
        this.routerKey++
    }
})
